module.exports = __webpack_public_path__ + "img/sandtimer@3x.39c5dbfa.png";